/* istanbul ignore file */

import { maxBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  text = theme.text;
var headingFont = /*#__PURE__*/css(["font-family:", ";font-weight:", ";font-size:", ";"], fonts.PRIMARY_SEMIBOLD.family, fonts.PRIMARY_SEMIBOLD.weight, pxToRem(text.HEADING.XS.fontSize));
export var copyContainer = /*#__PURE__*/css(["text-align:var(--textAlignment);table{border-collapse:collapse;border-spacing:0;}th,th > p{", "}td,th{border:1px solid var(--neutral-black-10);padding:5px;", ";}tr td:first-child,tr td:first-child > p{", ";}"], headingFont, mediaQuery({
  max: maxBreakpoints.M
}, css(["display:block;"])), mediaQuery({
  max: maxBreakpoints.M
}, css(["", ""], headingFont)));